import api from './api';

export interface VisionMatch {
  person_uuid: string;
  first_name: string;
  last_name: string;
  company_name?: string;
  score: number;
}

export interface VisionRecognizeResponse {
  success: boolean;
  match: VisionMatch | null;
  threshold?: number;
  reason?: string;
  best_score?: number | null;
  error?: string;
  message?: string;
}

export interface VisionBatchResult {
  index: number;
  match: VisionMatch | null;
  reason: string | null;
  best_score?: number | null;
  error?: string;
}

export interface VisionRecognizeBatchResponse {
  success: boolean;
  threshold: number;
  results: VisionBatchResult[];
  error?: string;
  message?: string;
}

class VisionService {
  async recognize(image: Blob): Promise<VisionRecognizeResponse> {
    const form = new FormData();
    form.append('image', image, 'frame.jpg');
    const { data } = await api.post<VisionRecognizeResponse>('/vision/recognize', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  }

  async recognizeBatch(images: Blob[]): Promise<VisionRecognizeBatchResponse> {
    const form = new FormData();
    images.forEach((img, i) => form.append('images', img, `face_${i + 1}.jpg`));
    const { data } = await api.post<VisionRecognizeBatchResponse>('/vision/recognize-batch', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  }
}

const visionService = new VisionService();
export default visionService;

